<terra-main-nav />
<mat-sidenav-container [hasBackdrop]="true">
  <mat-sidenav #sidenav class="sidenav"
    mode="over" position="end" 
    [fixedInViewport]="true" 
    [fixedTopGap]="0"
    [fixedBottomGap]="0"
    [opened]="false"
    [style.visibility]="sidenav.opened ? 'visible' : 'hidden'">
    <ng-template #placeholder />
  </mat-sidenav>

  <mat-sidenav-content>
    <div #scrollable>
      <terra-notification-viewer />
      <router-outlet />
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
